export default __webpack_public_path__ + "static/3-2c777c9c870ec2b7d11beb55fc8c5913.png";